<cm-overlay>
  <cm-setup
    title="{{ 'SETUP_COMPLETE_TITLE' | translate }}"
    subTitle="{{ 'SETUP_COMPLETE_SUBTITLE' | translate }}"
    [showOk]="true"
    (okPressed)="onOk($event)"
  ></cm-setup>
</cm-overlay>
